import { DepType } from './types/types';

export const DAY_W = 52;
export const WEEK_DAY_W = 52;   
export const MONTH_DAY_W = 11;  
export const ROW_H = 48;
export const HEADER_H = 56;
export const BAR_PAD = 7;

export const DEP_TYPES: { code: DepType; label: string }[] = [ /* ... */ ];

export const ACTION_STATUSES = ['Open', 'InProgress', 'Closed'] as const;
export type ActionStatus = (typeof ACTION_STATUSES)[number];
export const CLOSED_STATUS: ActionStatus = 'Closed';

export const STATUS_COLOR: Record<ActionStatus, string> = {
  Open:       '#7c3aed',
  InProgress: '#f0ad4e',
  Closed:     '#5cb85c',
};